import { number_format, tracking } from '@bark/bark-core';
import { trackingPayload } from './cs-subscription-tracking';

export default function () {
	const { Handlebars } = window;

	const domElements = {
		modalId: 'cs-sub-payment-summary-modal',
		paymentModalHeaderContainer: 'cs-sub-payment-modal-header-container',
		paymentModalPackSummaryContainer: 'cs-sub-payment-modal-pack-summary-container',
		paymentModalCardDetailsContainer: 'cs-sub-payment-modal-card-details-container',
		paymentModalTermsLinkContainer: 'cs-sub-payment-modal-terms-link-container',
	};

	const hbTemplates = {
		paymentModalHeader: Handlebars.compile(
			document.getElementById('cs-sub-payment-modal-header').innerText,
		),
		paymentModalPackSummary: Handlebars.compile(
			document.getElementById('cs-sub-payment-modal-pack-summary').innerHTML,
		),
		paymentModalCardDetails: Handlebars.compile(
			document.getElementById('cs-sub-payment-modal-card-details').innerHTML,
		),
		paymentModalTermsLink: Handlebars.compile(
			document.getElementById('cs-sub-payment-modal-terms-link').innerHTML,
		),
	};

	const show = (
		currencySymbol,
		paymentCard,
		selectedPackage,
		selectedPaymentFrequency,
		successCallback,
		changeCardCallback,
	) => {
		buildModal(currencySymbol, paymentCard, selectedPackage, selectedPaymentFrequency);
		bindListeners(successCallback, changeCardCallback);
		$(`#${domElements.modalId} .secure-footer`).addClass('rounded-bottom');
		$(`#${domElements.modalId}`).modal('show');
	};

	const buildModal = (
		currencySymbol,
		paymentCard,
		selectedPackage,
		selectedPaymentFrequency,
	) => {
		$(`#${domElements.paymentModalHeaderContainer}`)
			.empty()
			.append(hbTemplates.paymentModalHeader());
		$(`#${domElements.paymentModalPackSummaryContainer}`)
			.empty()
			.append(
				hbTemplates.paymentModalPackSummary({
					packageName: selectedPackage?.name === 'silver' ? 'Recommended' : 'Custom',
					creditsPerMonth: selectedPackage?.credits_per_month,
					creditsPerWeek: selectedPackage?.credits_per_week,
					pricePerMonth:
						currencySymbol +
						number_format(selectedPackage?.price_per_month_in_pence / 100, 2),
					pricePerWeek:
						currencySymbol +
						number_format(selectedPackage?.price_per_week_in_pence / 100, 2),
					pricePerCredit: selectedPackage?.price_per_credit_in_pence
						? currencySymbol +
						  number_format(selectedPackage.price_per_credit_in_pence / 100, 2)
						: '',
					isWeekly: selectedPaymentFrequency === 'week',
					isMonthly: selectedPaymentFrequency === 'month',
				}),
			);
		$(`#${domElements.paymentModalCardDetailsContainer}`)
			.empty()
			.append(
				hbTemplates.paymentModalCardDetails({
					cardBrandImage: paymentCard.card_brand_image,
					cardLastFour: paymentCard.card_number,
				}),
			);
		$(`#${domElements.paymentModalTermsLinkContainer}`)
			.empty()
			.append(hbTemplates.paymentModalTermsLink());
	};

	const bindListeners = (successCallback, changeCardCallback) => {
		$(`#${domElements.modalId} .js-subscribe-btn`)
			.off('click')
			.on('click', function (e) {
				$(`#${domElements.modalId}`).modal('hide');
				tracking(
					'credit-subscription-self-service-page-checkout',
					'click_subscribe',
					trackingPayload,
				);
				successCallback?.();
			});
		$(`#${domElements.modalId} #js-cs-sub-payment-modal-change-card`)
			.off('click')
			.on('click', function (e) {
				$(`#${domElements.modalId}`).modal('hide');
				tracking(
					'credit-subscription-self-service-page-checkout',
					'card_on_file_click_change',
					trackingPayload,
				);
				changeCardCallback?.();
			});
		$(`#${domElements.modalId} .js-cancel-button`)
			.off('click')
			.on('click', function (e) {
				tracking(
					'credit-subscription-self-service-page-checkout',
					'click_cancel',
					trackingPayload,
				);
			});
	};

	return {
		show,
	};
}
